import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import AutohideSnackbar from './AutohideSnackbar';
import ClientProvider from './client';
export default createDemo(import.meta.url, AutohideSnackbar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/snackbars/demos/autohide/AutohideSnackbar.tsx",
    "fileName": "AutohideSnackbar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Snackbar from '@mui/material/Snackbar';\nimport type { SnackbarCloseReason } from '@mui/material/Snackbar';\n\nexport default function AutohideSnackbar() {\n  const [open, setOpen] = React.useState(false);\n\n  const handleClick = () => {\n    setOpen(true);\n  };\n\n  const handleClose = (\n    event: React.SyntheticEvent | Event,\n    reason?: SnackbarCloseReason,\n  ) => {\n    if (reason === 'clickaway') {\n      return;\n    }\n\n    setOpen(false);\n  };\n\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Button onClick={handleClick}>Open Snackbar</Button>\n      <Snackbar\n        open={open}\n        autoHideDuration={5000}\n        onClose={handleClose}\n        message=\"This Snackbar will be dismissed in 5 seconds.\"\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 35,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Snackbar from '@mui/material/Snackbar';\nimport type { SnackbarCloseReason } from '@mui/material/Snackbar';\n\nexport default function AutohideSnackbar() {\n  const [open, setOpen] = React.useState(false);\n\n  const handleClick = () => {\n    setOpen(true);\n  };\n\n  const handleClose = (\n    event: React.SyntheticEvent | Event,\n    reason?: SnackbarCloseReason,\n  ) => {\n    if (reason === 'clickaway') {\n      return;\n    }\n\n    setOpen(false);\n  };\n\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Button onClick={handleClick}>Open Snackbar</Button>\n      <Snackbar\n        open={open}\n        autoHideDuration={5000}\n        onClose={handleClose}\n        message=\"This Snackbar will be dismissed in 5 seconds.\"\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onClick"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleClick"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Open Snackbar</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Snackbar"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "open"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "open"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "autoHideDuration"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "5000"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "onClose"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleClose"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "message"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "This Snackbar will be dismissed in 5 seconds.",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 35,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Button",
      "@mui/material/Snackbar"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
